// Module
var code = "<div class=\"table-responsive\">\n    <jst template-url=\"directives/scanResultsResponsiveTable.jst\" using=\"data\"></jst>\n</div>\n";
// Exports
module.exports = code;